// src/lang/zh-hk.js（香港繁体）
export default {
  // 导航栏文案（适配香港用语）
  nav: {
    home: '首頁',
    groupIntroduction: '集團簡介',
    portLogistics: '港航物流', // 香港繁体与简体术语一致，仅字形繁化
    industrialBase: '產業园',
    characteristicTown: '特色小鎮',
    newsCenter: '資訊中心',
    downloadCenter: '資料下載',
    aboutUs: '聯繫我們',
  },
  footer: {
    linkTitle: '友情鏈接',
    nav: {
      home: '網站首頁',
      about: '聯繫我們',
      recruit: '人才招聘',
      contact: '聯繫我們',
      message: '在線留言',
      download: '下載中心',
      rss: '訂閱RSS'
    },
    contact: {
      address: '地址：',
      phone: '電話：',
      email: '電郵：',
      addressValue: '香港中環皇后大道中302號北海商業大厦6F',
      phoneValue: '(+852)2139 5018',
      emailValue: 'chenxm@pntg.com.hk'
    },
    copyright: 'Copyright 2010-2016 普泰（香港）集團有限公司 All Rights Reserved',
    record: '浙ICP備15012664號-2',
  },
  friendLinks: {
    realEstate: '中國房地產協會',
    logistics: '物流與採購聯合會',
    environmental: '環保產業協會',
    building: '中國建築科學研究院',
    trade: '國際貿易促進委員會',
    huzhou: '湖州經濟開發區',
    haining: '海寧市府官網',
    suzhou: '蘇州市商務局',
    guangxi: '廣西投資促進局',
    economy: '中國經濟網',
    enterpriseNews: '企業新聞網'
  },
  project: {
    mainTitle: '集團項目',
    subtitle: '普泰集團多元化業務布局，涵蓋物流地產、商業地產、環保科技、工程建設和商品流通五大領域',
    viewProject: '查看項目 →',
    items: {
      logistics: {
        title: '物流地產',
        desc: '現代化智能物流園區建設與運營管理'
      },
      commercial: {
        title: '商業地產',
        desc: '城市綜合體與商業配套設施開發與項目管理'
      },
      environmental: {
        title: '環保科技',
        desc: '綠色環保技術研發與應用推廣'
      },
      engineering: {
        title: '工程建設',
        desc: '各類工程項目總包與管理服務'
      },
      circulation: {
        title: '商品流通',
        desc: '高品質商品供應鏈管理服務'
      }
    },
    ProjectClassification: '項目分類'
  },
  video: {
    mainTitle: '集團視頻展示',
    subtitle: '透過視頻了解普泰集團的發展歷程、企業文化和項目成就',
    items: {
      promo2025: {
        title: '普泰集團2025年度宣傳片',
        desc: '探索普泰集團的發展歷程、核心業務與未來願景，見證我們如何通過創新與卓越領跑行業。'
      },
      huzhouLogistics: {
        title: '湖州物流產業園項目介紹',
        desc: '詳細介紹普泰集團湖州物流產業園的規劃設計、建設進展和未來運營模式。'
      },
      ecoTech: {
        title: '普泰環保科技業務展示',
        desc: '展示普泰集團在環保科技領域的創新成果和可持續發展解決方案。'
      }
    }
  },
  filter: {
    filterByYear: '按年份篩選', // 按年份筛选（繁体）
    filterByType: '按類型篩選', // 按类型筛选（繁体）
    allNews: '全部資訊',    // 全部资讯（繁体）
    allTypes: '全部類型',    // 全部类型（繁体）
    yearSuffix: '年'
  },
  downloadCenter: {
    dataCategory: '資料分類', // 资料分类（香港繁体）
    allData: '全部資料',       // 全部资料（香港繁体）
    noDataTip: '當前分類下暫無可下載的資料' // 空数据提示（适配香港用语）
  },
  infoCards: {
    groupProfile: '集團簡介',
    groupNews: '集團動態',
    downloadCenter: '下載中心',
    moreNews: '更多動態',
    moreFiles: '更多檔案',
    groupName: '普泰（香港）集團',
    groupDesc: '普泰集團由菜亮軍先生、宣曉飛先生於2005年聯合創辦，是以港口物流、產業園等領域為主的投資集團。<br><br>普泰專注於成為中國具備一定影響力的產業投資開發及運營商，並始終倡導生態環保技術的開發與應用...'
  },
  groupIntro: {
    imgDesc: '普泰集團港口物流產業園實景',
    paragraph1: '普泰（香港）集團有限公司是以港口物流、物流地產等領域為主的投資集團。',
    paragraph2: '普泰在專注於成為中國大陸區域性最大的港口物流投資開發商及最具影響力的第三方物流解決方案提供商的同時，倡導生態環保技術的開發與應用。「低碳、綠色、環保」是普泰崇尚的核心經營理念，也是普泰的核心價值觀。',
    paragraph3: '普泰堅持不懈地打造綠色建造，以環境和諧為本，優化物流鏈、降低物流成本、提升物流效率、降低排放、改善環境，致力於成為行業創新者、領跑者及卓越的綠色企業，讓天更藍、水更綠。',
    corePosition: '核心定位',
    corePositionDesc: '中國大陸區域性最大的港口物流投資開發商',
    serviceObjective: '服務目標',
    serviceObjectiveDesc: '最具影響力的第三方物流解決方案提供商',
    devPhilosophy: '發展理念',
    devPhilosophyDesc: '綠色建造、環境和諧、行業創新領跑'
  },
  portLogistics: {
    // 分类标签
    overview: '港航物流概況',
    jiaxing: '嘉興內河港',
    deqing: '德清港',
    haining: '海寧港',

    // 港航物流概况
    overviewTitle: '港航物流概況',
    feature1: '透過投資建設具備港口裝卸、倉儲配送、市場交易及商務配套功能的港口物流園，實現交通運輸現代化、標準化、集約化。',
    feature2: '依托口岸「通關一體化」便利，讓內陸城市「通江達海」，提升國際競爭力。',
    feature3: '依托「海河聯運、車船港一體化、港港聯動」等集疏運模式，優化物流鏈，提高物流效率，降低物流成本。',
    feature4: '透過「陸改水、散改集」業務操作，降低碳排放，實現綠色低碳運輸。',
    feature5: '透過融合「人流、物流、資金流、信息流」，整合各方資源，形成資金高地、資訊中心，打造臨港產業集聚平台。',
    feature6: '做為區域地理經濟的公共服務平台，依托經濟一體化的便利，服務國內國際雙循環。',
    advantageTitle: '綜合物流優勢',
    advantage1: '拆裝箱及倉儲',
    advantage2: '口岸及物流金融',
    advantage3: '內支線對接母港',
    advantage4: '冷庫及冷鏈配送',

    // 嘉兴内河港
    jiaxingTitle: '嘉興內河港 · 國際多用途港區',
    jiaxingOverview: '位於嘉興市南湖區，是浙江省重點基建專案及國家交通運輸部規劃的全國主要內河港口之一。',
    jiaxingParam1: '總佔地面積：32.6萬平方米',
    jiaxingParam2: '泊位岸線長度：570米',
    jiaxingParam3: '設計年吞吐量：35萬標箱',
    jiaxingParam4: '當前年吞吐量：22萬標箱',
    jiaxingFacilityTitle: '配套設施：',
    jiaxingFacility1: '口岸管理機關',
    jiaxingFacility2: '配套貨物查驗熏蒸',
    jiaxingFacility3: '高標準倉庫',
    jiaxingFacility4: '貨物檢查',
    jiaxingFacility5: '熏蒸消毒',
    jiaxingFacility6: '資訊平台',
    jiaxingPosition: '致力於成為提供全面口岸功能與物流服務的主要集散港，支援上海國際航運中心建設。',
    jiaxingImg1Alt: '嘉興內河港集裝箱作業區',
    jiaxingImg2Alt: '嘉興內河港航拍圖',
    jiaxingImg3Alt: '嘉興內河港口岸辦公樓',

    // 德清港
    deqingTitle: '德清港',
    deqingParam1: '岸線長度：510米',
    deqingParam2: '千噸級多用途泊位：7個',
    deqingParam3: '年吞吐量：350萬噸',
    deqingParam4: '集裝箱吞吐量：30萬TEU',
    deqingModeTitle: '「車船港」一體化運作模式',
    deqingModeDesc: '透過杭平申線、湖嘉申線和京杭大運河等內河航道，集裝箱可在18-28小時內到達乍浦、上海、太倉等沿海港口，實現海河聯運，為德清及周邊地區企業的大宗貨物進出口提供便利。',
    deqingDevelopTitle: '發展成果',
    deqingDevelopDesc1: '2015年12月16日開港運營以來，德清港開拓創新，充分發揮「陸海河聯運、區港園聯動、車船港一體化」等優勢：',
    deqingDevelop1: '透過打造倉儲、配送、報關、檢驗檢疫等一票式服務',
    deqingDevelop2: '在引進船公司、開闢新航線、擴大貨源市場、延伸物流服務等方面下功夫',
    deqingDevelop3: '為內河集裝箱發展激活活力、打下堅實基礎',
    deqingDevelopDesc2: '次年吞吐量突破10萬標箱，德清迎來了全新的港口時代。',
    deqingImg1Alt: '德清港集裝箱作業區',
    deqingImg2Alt: '德清港園區航拍圖',

    // 海宁港
    hainingTitle: '海寧港物流園',
    hainingParam1: '總投資：2.5億美元',
    hainingParam2: '總佔地面積：550畝',
    hainingParam3: '岸線長度：386米',
    hainingParam4: '千噸級多用途泊位：8個',
    hainingParam5: '集裝箱年吞吐量：30萬標箱',
    hainingFunctionTitle: '具備五大功能',
    hainingFunction1: '口岸',
    hainingFunction2: '集裝箱',
    hainingFunction3: '冷鏈及倉儲',
    hainingFunction4: '商品貿易',
    hainingFunction5: '資訊平台',
    hainingQualificationTitle: '專案資質',
    hainingQualification1: '浙江省重點工程',
    hainingQualification2: '浙江省服務業重大專案',
    hainingQualification3: '浙江省十二五海洋經濟發展重大建設專案',
    hainingImg1Alt: '海寧港區位交通圖',
    hainingImg2Alt: '海寧港區域位置圖',
    hainingImg3Alt: '海寧港作業區'
  },
  industrialBase: {
    // 通用标题/标签
    categoryTitle: '產業基地',
    projectLocation: '專案區位：',
    trafficAdvantage: '交通優勢：',
    coreParameters: '核心參數：',
    buildingFacilities: '建築設施：',
    keyIntroducedIndustries: '重點引進產業：',
    benefitAfterCompletion: '達產後效益：',
    carrierPositioning: '載體定位：',
    trafficLocationAdvantage: '交通區位優勢：',
    industrialPositioning: '產業定位：',
    parkGoal: '園區目標：',
    locationDistanceAdvantage: '區位距離優勢：',
    parkPositioning: '園區定位：',

    // 产业园名称
    suzhou: '科棲（蘇州）產業園',
    suzhouNewMaterial: '蘇州國際新材料產業園',
    xishan: '普泰易商錫山智慧製造基地',
    bowang: '科棲（博望）產業園',
    fangchenggang: '科棲（防城港）產業園',

    // 科栖（苏州）产业园详情
    suzhouLocation: '專案位於蘇州高新區，是區域重點產業載體之一。',
    suzhouTraffic1: '地鐵3號線文昌路站在產業園內',
    suzhouTraffic2: '毗鄰京杭大運河、蘇州中環線',
    suzhouTraffic3: '距高鐵蘇州新區站僅兩站地鐵路程，交通極為便利',
    suzhouParam1: '總占地面積：184畝',
    suzhouParam2: '規劃建築面積：約30萬方',
    suzhouParam3: '計畫總投資：15億元（分3期開發）',
    suzhouParam4: '預計引進企業：100家左右優質高科技企業',
    suzhouParam5: '達產後年稅收：2億元以上',
    suzhouImg1Alt: '科棲（蘇州）產業園區位圖',
    suzhouImg2Alt: '科棲（蘇州）產業園整體效果圖',
    suzhouImg3Alt: '科棲（蘇州）產業園實景圖',
    suzhouImg4Alt: '科棲（蘇州）產業園建築外觀',

    // 苏州国际新材料产业园详情
    suzhouNewMaterialLocation: '位於蘇州高新區蘇化路，已成為滸墅關經開區重要的產業承接載體。',
    suzhouNewMaterialParam1: '總開發面積：約60畝',
    suzhouNewMaterialParam2: '總建築面積：150000平米',
    suzhouNewMaterialFacilities: '主要為一棟甲類倉庫及兩棟四層級高標準丙類工業設施',
    suzhouNewMaterialIndustry1: '汽車零部件',
    suzhouNewMaterialIndustry2: '智慧裝備製造',
    suzhouNewMaterialIndustry3: '半導體',
    suzhouNewMaterialIndustry4: '生物醫藥',
    suzhouNewMaterialIndustry5: '醫療器械',
    suzhouNewMaterialIndustry6: '新材料',
    suzhouNewMaterialBenefit1: '預計新增註冊資本超5億元',
    suzhouNewMaterialBenefit2: '年產值超30億元',
    suzhouNewMaterialBenefit3: '年繳納稅收超2億元',
    suzhouNewMaterialBenefit4: '新增高新技術企業6家以上',
    suzhouNewMaterialImg1Alt: '蘇州國際新材料產業園整體效果圖',
    suzhouNewMaterialImg2Alt: '蘇州國際新材料產業園倉庫實景',
    suzhouNewMaterialImg3Alt: '蘇州國際新材料產業園工業設施外觀',

    // 普泰易商锡山智能制造基地详情
    xishanLocation: '位於無錫市錫山經濟技術開發區。',
    xishanParam1: '建設用地面积：約93畝',
    xishanParam2: '總建築面積：98571平方米',
    xishanParam3: '建設內容：生產廠房及相關配套設施',
    xishanParam4: '總投資：約1.5億美元',
    xishanCarrierPosition: '錫山智慧製造基地為高標準載體平台',
    xishanIndustry1: '高端裝備製造',
    xishanIndustry2: '汽車零部件',
    xishanIndustry3: '電子通訊設備',
    xishanBenefit1: '預計年產值：近10億元人民幣',
    xishanBenefit2: '預期年納稅：近4700萬元人民幣',
    xishanBenefit3: '年綜合稅收：約50萬元/畝',
    xishanBenefit4: '擬吸納就業人數：超1000人',
    xishanImg1Alt: '錫山智慧製造基地整體效果圖',
    xishanImg2Alt: '錫山智慧製造基地配套設施',
    xishanImg3Alt: '錫山智慧製造基地建築外觀',

    // 科栖（博望）产业园详情
    bowangLocation: '位於馬鞍山市博望區，是博望現代產業融合示範區核心載體之一。',
    bowangParam1: '總占地面積：200畝',
    bowangParam2: '專案總投資：12億元',
    bowangParam3: '一期占地面積：100畝',
    bowangParam4: '一期建築面積：約5.5萬方',
    bowangParam5: '一期總投資：6億元',
    bowangTraffic1: '距馬鞍山站約40KM',
    bowangTraffic2: '距祿口機場約30KM',
    bowangTraffic3: '距溧水站約40KM、當塗東站約36KM',
    bowangIndustrialPosition: '以高標準廠房為載體，聚焦裝備製造、智慧製造、新一代資訊技術、新材料等產業。',
    bowangParkGoal: '致力於打造博望現代產業融合示範區，建設現代化新型產業空間，招引和集聚一批高成長潛力的中小企業，成為博望產業升級進位的新引擎。',
    bowangImg1Alt: '科棲（博望）產業園交通區位圖',
    bowangImg2Alt: '科棲（博望）產業園規劃圖',
    bowangImg3Alt: '科棲（博望）產業園廠房效果圖',

    // 科栖（防城港）产业园详情
    fangchenggangLocation: '位於防城港市東部，臨近防城港港口，是防城港市小微企業新中心核心載體。',
    fangchenggangDistance1: '距離防城港市區10.9公里',
    fangchenggangDistance2: '距離防城港港口15.1公里',
    fangchenggangParam1: '總占地面積：111畝',
    fangchenggangParam2: '規劃建築面積：約6.6萬方',
    fangchenggangParam3: '總投資：2.2億元人民幣',
    fangchenggangParkPosition: '打造集生產、展示、商務、辦公為一體化的生產基地型綜合園區，塑造防城港工業園區新形象，構建規範化、專業化、集群化生產園區，成為防城港市小微企業新中心。',
    fangchenggangImg1Alt: '科棲（防城港）產業園區位圖'
  },
  characteristicTown: {
    // 通用标题/标签
    categoryTitle: '特色小鎮',
    projectLocation: '專案區位：',
    projectOverview: '專案概況：',
    surroundingEcologicalEnvironment: '周邊生態環境：',
    planningMapAlt: '滸墅關綠色技術小鎮規劃圖',

    // 浒墅关特色小镇相关
    xushuguan: '滸墅關特色小鎮',
    xushuguanGreenTechTown: '滸墅關綠色技術小鎮',
    xushuguanLocationDesc: '位於蘇州市高新區滸墅關經開區核心區域，小鎮邊界為：',
    eastTo: '東至：蘇滸路',
    southTo: '南至：312國道-大新河',
    westTo: '西至：312國道-文昌路',
    northTo: '北至：通滸路',
    xushuguanOverviewDesc: '由普泰集團與滸墅關經開區管委會聯合打造',
    planningArea: '規劃面積：3.4平方公里',
    constructionLandArea: '建設用地面积：約2100畝',
    totalInvestment: '總投資額：350億',

    // 上城·浒关运河文化古镇
    upperTown: '上城·滸關運河文化古鎮',
    upperTownDesc: '推動城市更新，形成蘇州城市西北門戶，成為蘇州文化休閒新地標和中國大運河文化復興典範',
    upperTownInvestment: '總投資：約160億',

    // 下城·绿色产业新城
    lowerTown: '下城·綠色產業新城',
    lowerTownDesc: '導入聯合國工發綠色產業園理念，圍繞新一代資訊技術、智慧製造、醫療器械、5G產業，打造工業4.0概念的產業新城',
    lowerTownInvestment: '總投資：約190億',

    // 周边生态环境
    ecologicalEnv1: '東部7公里處，是近兩萬畝的蘇州北部綠肺虎丘濕地公園',
    ecologicalEnv2: '西側4公里處為江蘇大陽山國家森林公園，西距太湖13公里，是蘇州大生態休閒線路上的重要節點'
  },
  common: {
    backHome: '返回首頁',
    backList: '返回列表'
  }
}